'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

/* eslint-disable @typescript-eslint/no-empty-function */
var PopupContext = react.createContext({
    closePopup: function () { },
    isDisplayed: false,
    popperRef: {},
    togglePopup: function () { }
});

exports.default = PopupContext;
//# sourceMappingURL=PopupContext.js.map
